module.exports = __webpack_public_path__ + "img/icon-sql.fd3d522e.svg";